module.exports = __webpack_public_path__ + "static/media/forwardhead_normal_left.63872890.png";